import { render, staticRenderFns } from "./VirtualKeyboard65Less.vue?vue&type=template&id=71449765&scoped=true&"
import script from "./VirtualKeyboard65Less.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard65Less.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard65Less.vue?vue&type=style&index=0&id=71449765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71449765",
  null
  
)

export default component.exports